import { Shield } from 'lucide-react';
import { legalConfig } from '../config/legal';

type Props = {
  message: string;
  className?: string;
};

/** Staff-facing banner for Tier B / sensitive data screens. */
export function SensitiveDataBanner({ message, className = '' }: Props) {
  return (
    <div className={`flex gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950 ${className}`}>
      <Shield className="h-5 w-5 shrink-0 text-amber-700 mt-0.5" />
      <div>
        <p>{message}</p>
        <p className="mt-2 text-xs text-amber-900/80">
          Exercice des droits :{' '}
          <a href={`mailto:${legalConfig.privacyContactEmail}`} className="underline font-medium">
            {legalConfig.privacyContactEmail}
          </a>
          {' · '}
          <a
            href={legalConfig.staffPrivacyNoticeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-medium"
          >
            Procédures internes
          </a>
        </p>
      </div>
    </div>
  );
}
